export const getLocation = async () => {

  try {

    const controller = new AbortController();

    const timeout = setTimeout(
      () => controller.abort(),
      1500
    );

    const res = await fetch(
      "https://ipapi.co/json/",
      { signal: controller.signal }
    );

    clearTimeout(timeout);

    const data = await res.json();

    return {
      country: data.country_name,
      city: data.city,
      region: data.region,
    };

  } catch {
    return {};
  }

};